console.log("welcome common js");

/* Please ❤ this if you like it! */

var swiper = new Swiper(".homeTestimonialsBlockSwiper", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  swiper: true,
  spaceBetween: 700,
  slidesPerView: 1,
});

(function ($) {
  "use strict";

  $(function () {
    var header = $(".start-style");
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 10) {
        header.removeClass("start-style").addClass("scroll-on");
      } else {
        header.removeClass("scroll-on").addClass("start-style");
      }
    });
  });
  //Switch light/dark

  // overFlowHidden
  $("#burger").click(function (e) {
    e.stopPropagation();
    $("body").toggleClass("overFlowHidden");
  });

  $("html").click(function (e) {
    if ($(e.target).closest(div).length == 0)
      $("body").removeClass("overFlowHidden");
  });
  $(".menu-link.nav-link").click(function (e) {
    $("body").removeClass("overFlowHidden");
    $(".burger").removeClass("active");
    // $(".menu").removeClass("active").css("max-height", "0 !important");
    $(".menu").removeClass("active");
    if (window.matchMedia("(max-width: 991px)").matches) {
      navbarMenu.style.maxHeight = 0 + "px";
    } else {
      return;
    }
  });
  // overFlowHidden
})(jQuery);
// CURRENT PAGE ACTIVE
// $(function () {
//   $('nav a[href^="/' + location.pathname.split("/")[1] + '"]').addClass(
//     "active"
//   );
// });
// CURRENT PAGE ACTIVE

// HEADER RESPONSIVE
// Initialize All Required DOM Element
const burgerMenu = document.getElementById("burger");
const navbarMenu = document.getElementById("menu");

// Initialize Responsive Navbar Menu
burgerMenu.addEventListener("click", () => {
  burgerMenu.classList.toggle("active");
  navbarMenu.classList.toggle("active");

  if (navbarMenu.classList.contains("active")) {
    navbarMenu.style.maxHeight = navbarMenu.scrollHeight + "px";
  } else {
    navbarMenu.removeAttribute("style");
  }
});

// HEADER RESPONSIVE
